/* =========================================================
   DOPAMEAN — Size filter grouping (TOPS / BOTTOMS)
   Splits a single "Size" facet into two sections: alphabetic
   sizes (S, M, L, XL…) under TOPS and numeric sizes (28, 30,
   32…) under BOTTOMS. Runs on the mobile drawer + the desktop
   vertical filter form, and re-runs after AJAX facet refresh.
   ========================================================= */
(function () {
  const HEADING_CLASS = 'dpm-size-group-heading';
  const PROCESSED_ATTR = 'data-dpm-size-grouped';

  function hasAlpha(text) {
    if (!text) return false;
    return /[A-Za-z]/.test(text);
  }

  function getValueLabelText(li) {
    const el = li.querySelector('.facet-checkbox__text-label');
    return el ? el.textContent : li.textContent;
  }

  function findSizeLists(root) {
    const lists = [];
    // Mobile drawer (inline sections): the Size section is marked in
    // snippets/facets.liquid with data-dpm-size-filter.
    root.querySelectorAll('[data-dpm-size-filter] .mobile-facets__list').forEach((ul) => lists.push(ul));
    // Mobile drawer (older sub-screen markup): each filter is a <details>; summary text = label
    root.querySelectorAll('.mobile-facets__details').forEach((d) => {
      const summary = d.querySelector('.mobile-facets__summary span');
      const label = summary ? summary.textContent.trim().toLowerCase() : '';
      if (label === 'size' || label.indexOf('size') !== -1) {
        const ul = d.querySelector('.mobile-facets__list');
        if (ul) lists.push(ul);
      }
    });
    // Desktop vertical/horizontal: each filter sits in a <facet-filter> details/summary
    root.querySelectorAll('.facets-wrap details, facet-filter details, .facets__disclosure').forEach((d) => {
      const summary = d.querySelector('summary');
      const label = summary ? summary.textContent.trim().toLowerCase() : '';
      if (label.indexOf('size') !== -1) {
        const ul = d.querySelector('ul.facets__list, ul.facets-layout-list, ul.list-unstyled');
        if (ul) lists.push(ul);
      }
    });
    return Array.from(new Set(lists));
  }

  function makeHeading(text) {
    const li = document.createElement('li');
    li.className = HEADING_CLASS;
    li.setAttribute('role', 'presentation');
    li.textContent = text;
    return li;
  }

  function groupList(ul) {
    if (!ul || ul.getAttribute(PROCESSED_ATTR) === '1') return;

    const items = Array.from(ul.children).filter((el) => el.tagName === 'LI' && !el.classList.contains(HEADING_CLASS));
    if (items.length === 0) return;

    const tops = [];
    const bottoms = [];
    items.forEach((li) => {
      if (hasAlpha(getValueLabelText(li))) tops.push(li);
      else bottoms.push(li);
    });

    // Only group if both buckets have items; otherwise leave alone.
    if (tops.length === 0 || bottoms.length === 0) {
      ul.setAttribute(PROCESSED_ATTR, '1');
      return;
    }

    // Remove existing headings (in case of re-run on a partially-processed list)
    ul.querySelectorAll('.' + HEADING_CLASS).forEach((h) => h.remove());

    const frag = document.createDocumentFragment();
    frag.appendChild(makeHeading('Tops'));
    tops.forEach((li) => frag.appendChild(li));
    frag.appendChild(makeHeading('Bottoms'));
    bottoms.forEach((li) => frag.appendChild(li));

    // Replace children
    while (ul.firstChild) ul.removeChild(ul.firstChild);
    ul.appendChild(frag);
    ul.setAttribute(PROCESSED_ATTR, '1');
  }

  function run(root) {
    const scope = root || document;
    findSizeLists(scope).forEach(groupList);
  }

  function clearProcessed(root) {
    (root || document).querySelectorAll('[' + PROCESSED_ATTR + ']').forEach((el) => el.removeAttribute(PROCESSED_ATTR));
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  // Re-run after Dawn replaces facets sections via AJAX.
  //
  // IMPORTANT: groupList() mutates the DOM (re-orders <li>s and toggles a
  // data attribute) — if the observer is naively bound with childList:true
  // / subtree:true, the mutation re-triggers the callback in an infinite
  // loop, freezing the page (this was breaking the theme editor preview).
  //
  // Fix: disconnect the observer before mutating, reconnect after a tick.
  // Use a debounce so rapid Dawn AJAX swaps don't queue extra runs.
  const observerTargets = ['#FacetFiltersFormMobile', '#FacetFiltersForm', '#main-collection-product-grid', '#ProductGridContainer'];

  observerTargets.forEach((sel) => {
    const node = document.querySelector(sel);
    if (!node) return;

    let scheduled = false;
    const obs = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      obs.disconnect();
      // Defer to next animation frame so the burst of mutations finishes,
      // then run our pass, then reconnect.
      requestAnimationFrame(() => {
        try {
          clearProcessed(node);
          run(node);
        } finally {
          scheduled = false;
          obs.observe(node, { childList: true, subtree: true });
        }
      });
    });
    obs.observe(node, { childList: true, subtree: true });
  });

  // Also listen for Dawn's section-load event — cleaner trigger than the
  // MutationObserver and won't fire on every paint.
  document.addEventListener('shopify:section:load', () => run());
})();
